// extracted by mini-css-extract-plugin
export default {"text-selected":"table-column-header_text-selected__Vx6bO","text-one-line":"table-column-header_text-one-line__EQW9r"};